import React, { useEffect, useState } from 'react';
import { useQuery, useLazyQuery } from '@apollo/react-hooks';

import DisplayAnalyticsController from './DisplayAnalyticsContorller';
import moment from 'moment';
import OverlaySpinner from '../../../../platform/shared/OverlaySpinner';
import CAMPAIGN_ORDERS_AGGREGATE_BYDATE from '../../../GraphQl/Queries/CAMPAIGN_ORDERS_AGGREGATE_BYDATE';
import LIST_ORGS_ADVERTISERS from '../../../GraphQl/Queries/LIST_ORGS_ADVERTISERS';

const DisplayAnalyticsLoader = ({ children, ...props }) => {
  const loggedInRole = props.currentUser.role;
  const org = loggedInRole.org;
  const orgId = loggedInRole.org.id;

  const searchParams = new URLSearchParams(props.location.search);
  const advertiserParams = searchParams.get('advertiserId');

  const startDate = searchParams.get('startDate')
    ? searchParams.get('startDate')
    : moment().subtract(6, 'months').seconds(0).milliseconds(0).toISOString();
  const endDate = searchParams.get('endDate')
    ? searchParams.get('endDate')
    : moment().add(1, 'days').seconds(0).milliseconds(0).toISOString();

  const [advertiserIds, setAdvertiserIds] = useState([orgId]);

  useEffect(() => {
    if (!advertiserParams) {
      return setAdvertiserIds([orgId]);
    }
    const advertisers = advertiserParams.split('+');
    setAdvertiserIds(advertisers);
  }, [advertiserParams, orgId]);

  const statusNotIn = ['DRAFT', 'PENDING', 'ARCHIVED'];
  let where = {
    AND: [],
  };

  where['AND'].push({
    type_not: 'CPC',
    status_not: 'ARCHIVED',
  });

  where['AND'].push({
    AND: [],
  });

  if (startDate && endDate) {
    let paramStartDate = moment(startDate, 'YYYY/MM/DD');
    let paramEndDate = moment(endDate, 'YYYY/MM/DD');

    where['AND'].push({
      OR: [
        {
          startDate_gte: paramStartDate.seconds(0).milliseconds(0).toISOString(),
          startDate_lte: paramEndDate.seconds(0).milliseconds(0).toISOString(),
        },
        {
          endDate_gte: paramStartDate.seconds(0).milliseconds(0).toISOString(),
          endDate_lte: paramEndDate.seconds(0).milliseconds(0).toISOString(),
        },
        {
          startDate_lte: paramStartDate.seconds(0).milliseconds(0).toISOString(),
          endDate_gte: paramEndDate.seconds(0).milliseconds(0).toISOString(),
        },
      ],
    });
  }

  if (!(advertiserIds.length === 1 && advertiserIds[0] === orgId)) {
    where['AND'].push({
      status_not_in: statusNotIn,
      orgs_some: {
        OR: [
          { id_in: advertiserIds },
          {
            parentOrg_some: {
              id_in: advertiserIds,
            },
          },
        ],
      },
    });
  } else if (orgId) {
    where['AND'].push({
      status_not_in: statusNotIn,
      AND: {
        orgs_some: {
          OR: [
            {
              name: org.name,
            },
            {
              parentOrg_some: {
                id: org.id,
              },
            },
          ],
        },
      },
    });
  }

  const { loading, data } = useQuery(CAMPAIGN_ORDERS_AGGREGATE_BYDATE, { variables: { where } });

  // Load Sub-Orgs of the current user's Org for filtering the Campaign Main Table by Org
  const { loading: loadingOrgsAdmin, data: orgsData } = useQuery(LIST_ORGS_ADVERTISERS, {
    variables: { orgIds: advertiserIds, first: 1000 },
  });

  if (loading || loadingOrgsAdmin) return <OverlaySpinner />;

  return (
    <DisplayAnalyticsController
      {...props}
      children={children}
      data={data}
      startDate={startDate}
      endDate={endDate}
      orgs={orgsData?.orgs || []}
    />
  );
};

export default DisplayAnalyticsLoader;
